








































































































































































































































































import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import VehicleDetail from '@/models/VehicleDetail';
import VehicleService from '@/services/vehicle.service';
import LazyImage from '@/components/LazyImage.vue';
import { SelectedAttributeModel } from '@/models/AttributeModel';
import Shared from '@/common/shared';
import BaseServiceMixin from '@/mixins/base.service.mixin';
import eventBus from '@/common/bus';

@Component({
  name: 'CarDetail',
  components: {
    LazyImage,
  },
})
export default class CarDetail extends Mixins(BaseServiceMixin) {
  @Prop({ default: undefined })
  public vehicleData!: VehicleDetail;
  @Prop({ default: undefined })
  private selectedAttributes!: SelectedAttributeModel[];
  @Prop({ default: false })
  private isNarrow!: boolean;
  private carDialog: boolean = false;

  private image: string = '';
  private noImage: string = window.location.origin + '/assets/img/no-image.png';

  private vehicleService!: VehicleService;

  public created() {
    this.vehicleService = new VehicleService(this.axiosInstance);
  }

  private async mounted() {
    this.updateInternalStorage();
  }

  @Watch('vehicleData', { deep: true })
  private async updateInternalStorage() {
    await this.fetchImage();
  }

  private async fetchImage() {
    if (this.vehicleData.imageURL) {
      this.image = this.vehicleData.imageURL;
      return;
    }

    let image: string | null = null;
    this.image = '';
    try {
      if (this.vehicleData.regNo) {
        image = await this.vehicleService.GetImageByRegNo(
          this.vehicleData.regNo,
        );
      } else {
        image = await this.vehicleService.GetImageByDetail(this.vehicleData);
      }
    } catch (err) {
      // TODO: handle Error
    }

    if (image) {
      this.image = image;
    } else {
      eventBus.$emit('track', 'MissingImage', {
        ...this.vehicleData,
        regNo: '',
      });
      this.image = this.noImage;
    }
  }

  private get last() {
    return Object.keys(this.attributes).length - 1;
  }

  private get attributes(): any {
    const attributes: any = {};

    Shared.AttributeSettings.filter((a) => a.parent === null).forEach(
      (element) => {
        const childAttributes = Shared.AttributeSettings.filter(
          (a) => a.parent === element.index,
        );

        const selectedAttribute = this.selectedAttributes.find(
          (a) => a.type === element.attributeType,
        );

        if (selectedAttribute) {
          const childAttributeValues: string[] = this.selectedAttributes
            .filter((a) =>
              childAttributes.some((c) => c.attributeType === a.type),
            )
            .map((a) => a.description);

          const value = `${selectedAttribute.description}
            ${
              childAttributeValues.length
                ? '(' + childAttributeValues.join(',') + ')'
                : ''
            }`;

          attributes[selectedAttribute.title] = value;
        }
      },
    );

    return attributes;
  }
}
